<template>
  <div style="width: 100%">
    <mx-panel v-if="!IsDelete && value" :type="config.Type" :value="value" :config="Config" panel="SystemList2"
      :selected="selected" :index="index" @event="OnEvent">
      <template>
        <div class="flex-row" style="width: 100%">

          <div class="wf left" style="color: #878a99">名称</div>
          <div class="wf left" style="color: #878a99">视频状态</div>

          <div class="wf left" style="color: #878a99">创建时间</div>
          <div class="wf left" style="color: #878a99">操作</div>
        </div>
      </template>

      <template slot="content">
        <div class="flex-row start middle border-bottom" style="width: 100%; padding: 20px 0">

          <div class="wf flex-row start list active">
            {{ value.Title || value.Name }}
          </div>
          <div class="wf flex-row start list">

            <el-button :type="[1, 3].indexOf(value.UpState) > -1 ? 'danger' : 'success'" size="mini"> {{
              UpStateTitle }}</el-button>
          </div>
          <div class="wf flex-row start list">
            {{ value.CreateTime }}
          </div>
          <div class="wf flex-row start list">

            <div class="pointer active flex-row" @click="onPlay" v-if="value.UpState > 1">
              播放
            </div>
            <div class="pointer active flex-row" @click="onAct"  >
              {{ Act.Name }}
            </div>
            <el-dialog :title="value.Name" :visible.sync="dialogVideo" width="1000px" @close="onDialogClose">
              <video :src="SiteUrl + value.VideoPath" controls class="video" preload="auto" width="100%"
                ref="dialogVideo"></video>

            </el-dialog>

          </div>
        </div>
      </template>
      <div slot="button"></div>
    </mx-panel>
  </div>
</template>

<script>
import base from "matrix.node.ui/libs/panels/base.js";
export default {
  props: {
    config: Object,
    value: Object,
    index: Number,
    role: String,
    roleField: String,
    name: String,
    selected: Object,
  },
  mixins: [base],
  data() {
    return { IsModify: false, IsDelete: false, dialogVideo: false };
  },
  computed: {
    SiteUrl() {
      return this.$matrix.Config.ImageSite;
    },
    Config() {
      return Object.assign(
        { EventName: this.name ? this.name : "TypeEvent", IsDark: false },
        this.config
      );
    },
    IsDetail() {
      if (this.config.DetailView) return true
      return false
    },
    UpStateTitle() {
      if (this.value.UpState) {
        switch (this.value.UpState) {
          case 1:
            return "未上架";
          case 2:
            return "已上架";
          case 3:
            return "已下架";
          default:
            return "未上架"
        }
      }
    },
    Act() {
      let res = [
        { Name: "上架", Value: 1, Type: "Lesson.Chapter.Items.ManagerUp" },
        { Name: "下架", Value: 2, Type: "Lesson.Chapter.Items.ManagerDown" },
        { Name: "上架", Value: 3, Type: "Lesson.Chapter.Items.ManagerUp" }].find(t => { return t.Value === this.value.UpState })
      if (res) return res
      return ''
    },

  },
  methods: {
    OnEvent(e) {
      this.$emit("event", e);
    },
    onGoDetail() {
      let View = this.config.DetailView;
      if (!View) return this.$matrix.ShowError("未配置详情视图");
      this.$emit("goview", {
        View: View,
        ViewType: "详情",
        Data: this.value,
        Role: this.config.Role,
        RoleField: this.config.RoleField,
      });
    },

    onPlay() {
      this.dialogVideo = true
    },
    onAct() {
      console.log(this.Act.Type)
      this.$matrix.AddData(
        this.Context,
        {},
        {
          Type: this.Act.Type,
          Role: this.config.Role,
          RoleField: this.config.RoleField,
          Roles: this.config.Roles,
          RoleFieldData: this.config.RoleFieldData
        },
        (data) => {
          this.$emit('event', {
            target: 'item',
            name: 'Reload'
          })
        },
        this.value
      )

    },
    onDialogClose() {
      if (this.value.VideoPath) {
        this.$refs.dialogVideo.pause();
      }
      this.$emit('event', {
        target: 'item',
        name: 'Reload'
      })

    },
  },
};
</script>

<style scoped>
.wf {
  flex: 1;
}

.wf2 {
  flex: 2;
}

.border {
  border: 1px solid #eee;
}

.label_1,
.label_2,
.label_3 {
  border-radius: 4px;
  padding: 4px 6px;
  text-align: center;
}

.label_1 {
  background: #fbc451;

  color: #fff;
}

.label_2 {
  background: #a498cb;

  color: #fff;
}

.label_3 {
  background: #a7bba9;

  color: #fff;
}

.label_4 {
  background: #f49a71;

  color: #fff;
}

.label_5 {
  background: #6d72bb;

  color: #fff;
}

.active {
  color: #2d8cf0;
}

.text-line {
  text-decoration: line-through;
  color: gray;
}

span.button {
  color: #2d8cf0;
  cursor: pointer;
}

.image-box {
  width: 48px;
  height: 48px;
  border-radius: 4px;
  opacity: 1;
  background-color: rgba(243, 246, 249, 1);
  padding: 4px;
}

.border-bottom {
  border-bottom: 1px solid #e9ebec;
}
</style>
